// eslint-disable-next-line no-unused-vars
import React from 'react';
// eslint-disable-next-line no-unused-vars
import Helmet from 'react-helmet';
import { loadLanguagePack } from '@americanexpress/one-app-ducks';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import childRoutes from './childRoutes';

export const AxpSecureFileExpressPortal = ({ children }) => (
  <React.Fragment>
    <Helmet>
      <title>Amex File Exchange Express</title>
    </Helmet>
    {children}
  </React.Fragment>
);

AxpSecureFileExpressPortal.childRoutes = childRoutes;

export const loadModuleData = async ({ store }) => {
  const { dispatch } = store;
  await dispatch(
    loadLanguagePack('axp-secure-file-express-portal', {
      fallbackLocale: 'en-US',
    })
  );
};

AxpSecureFileExpressPortal.holocron = {
  name: 'axp-secure-file-express-portal',
  loadModuleData,
};

AxpSecureFileExpressPortal.propTypes = {
  children: PropTypes.shape({
    props: PropTypes.shape({
      route: PropTypes.shape({
        path: PropTypes.string,
      }),
    }),
  }),
};

AxpSecureFileExpressPortal.defaultProps = {
  children: null,
};

const hocChain = compose(oneAppModuleWrapper('axp-secure-file-express-portal'));

export default hocChain(AxpSecureFileExpressPortal);
